"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-RadioInput',
    label: 'c-RadioInput__label',
    disabled: 'c-RadioInput__disabled',
};
exports.Style = {
    [exports.CSS.container]: {
        display: 'flex',
        'align-items': 'center',
    },
    [exports.CSS.disabled]: {
        color: `${theme_1.DefaultTheme.font.color.error} !important`,
        'pointer-events': 'none',
    },
};
//# sourceMappingURL=radio.input.style.js.map